import { Monitor, Globe, Shield } from 'lucide-react';
import TTServiceCard from './TTServiceCard';

interface TTServicesGridProps {
  onGetFreeAccess: () => void;
}

const TTServicesGrid = ({ onGetFreeAccess }: TTServicesGridProps) => {
  const services = [
    {
      icon: Monitor,
      flag: "🇺🇸",
      title: "US Remote Desktop",
      features: [
        "Fast US-based desktops",
        "Starting from $67.50 TTD",
        "Perfect for trading & business"
      ],
      color: "red" as const,
      ttdPrice: "$67.50 TTD"
    },
    {
      icon: Globe,
      flag: "🇺🇸", 
      title: "US Residential Proxies",
      features: [
        "Clean residential IPs",
        "Starting from $10.13 TTD per IP",
        "Ideal for business & research"
      ],
      color: "black" as const,
      ttdPrice: "$10.13 TTD"
    },
    {
      icon: Shield,
      flag: "🇺🇸",
      title: "US Residential VPN",
      features: [
        "100% Residential IPs",
        "Starting from $33.75 TTD",
        "Secure business connections"
      ],
      color: "white" as const,
      ttdPrice: "$33.75 TTD"
    }
  ];

  return (
    <div className="grid md:grid-cols-3 gap-6 mb-8 flex-grow">
      {services.map((service, index) => (
        <TTServiceCard
          key={index}
          icon={service.icon}
          flag={service.flag}
          title={service.title}
          features={service.features}
          color={service.color}
          ttdPrice={service.ttdPrice}
          onGetFreeAccess={onGetFreeAccess}
        />
      ))}
    </div>
  );
};

export default TTServicesGrid;